<script>
  export let title
  export let subtitle
  export let coverImage
</script>

<section class="trip-intro">
  {#if coverImage}
    <img src={coverImage.src} alt={coverImage.alt}/>
  {/if}
  <div class="content">
    <div class="cover-image-overlay" />
    <h1>{title}</h1>
    {#if subtitle}<p>{subtitle}</p>{/if}
  </div>
</section>

<style>
  .trip-intro {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-block: var(--spacer-xxl);
    background: transparent;
    text-align: center;
  }

  .trip-intro:has(> img) {
    mask: linear-gradient(black 92%, rgba(0,0,0,0.6) 96%, transparent 100%);
  }

  img + .content .cover-image-overlay {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 130%;
    backdrop-filter: brightness(0%) saturate(110%) opacity(90%);
    mask: linear-gradient(transparent 0%, rgba(0,0,0,0.25) 10%, rgba(0,0,0,0.5) 85%, transparent 100%);
  }

  .trip-intro img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .trip-intro .content {
    width: 100%;
  }

  .trip-intro:has(> img) {
    margin-block-start: 0;
    height: min(40vh, 40ch);
  }

  img ~ .content {
    color: white;
    position: absolute;
    bottom: 2%;
    text-shadow: 1px 1px 8px black;
    padding-block-end: var(--spacer-xxl);
  }

  .content h1 {
    position: relative;
    z-index: 1;
    margin-block: 0;
  }

  .content p {
    position: relative;
    z-index: 1;
    margin-block: var(--spacer-xs);
    font-size: var(--font-size-lg);
  }
</style>
